import { defineStore } from 'pinia'
export const useCommonStore = defineStore('common', {
    state: () => {
        return {
            settings: {
                icons: {}
            },
        }
    },
    persist: true,
    actions: {
        settingActiveSidebarItems(iconKey, status) {
            this.settings.icons[iconKey] = status
        }
    }
})
